import { render, staticRenderFns } from "./CloseModal.vue?vue&type=template&id=17a3135a&scoped=true&"
import script from "./CloseModal.vue?vue&type=script&lang=js&"
export * from "./CloseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a3135a",
  null
  
)

export default component.exports